import { Typography } from '@progress/kendo-react-common';
import { KWELLO_ICON, KwelloSvgIcon } from '../icon/KwelloSvgIcon';

export function WidgetNoDataState() {
  return (
    <div className="widget-no-data-state">
      <KwelloSvgIcon icon={KWELLO_ICON.NO_DATA} />
      <Typography.h6>No data available</Typography.h6>
      <Typography.p>Try adjusting your filters.</Typography.p>
    </div>
  );
}
